module.exports = __webpack_public_path__ + "static/20230619_041-c2ae0ed045b775f22dad688ecd329617.jpg";